import React from 'react'
import {Container, Col, Row} from 'reactstrap'

class TapsHorizontal extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            tapsMenu: '',
        }
    }
    refactorAbv = (abv) => {
        let number = parseFloat(abv)
        return number
    }
    sizeItemByLocation = (items, position) => {
        if (this.state.location === 'pl5' && position === 'left'){
            return (
                <div className="column pl5-taps-left">
                    <div className="white taps-left-col">
                        {items.map(item => (
                            <div className="pl5-tap-item">
                                {item.brewery.replace("Brewery", "").replace("Brewing", "").replace("Company", "").replace("Co.", "").replace("Cooperative", "COOP")} {item.name} <span className="style">{item.style}</span> {this.refactorAbv(item.abv)}%
                            </div>
                        ))}
                    </div>
                </div>
            )
        } else if(this.state.location === 'pl5' && position === 'right'){
            return (
                <div className="column pl5-taps-right">
                    <div className="white taps-right-col">
                        {items.map(item => (
                            <div className="pl5-tap-item">
                                {item.brewery.replace("Brewery", "").replace("Brewing", "").replace("Company", "").replace("Co.", "").replace("Cooperative", "COOP")} {item.name.replace('Castle', "")} <span className="style">{item.style}</span> {this.refactorAbv(item.abv)}%
                            </div>
                        ))}
                    </div>
                </div>
            )
        } else if (this.state.location === 'pl9' && position === 'left'){
            return (
                <div className="column taps-left">
                    <div className="white taps-left-col">
                        {items.map(item => (
                            <div className="tap-item">
                            {item.brewery.replace("Brewery", "").replace("Brewing", "").replace("Company", "").replace("Co.", "").replace("Cooperative", "COOP")} 
                            {item.name} <span className="style">{item.style}</span> {this.refactorAbv(item.abv)}%
                        </div>
                        ))}
                        
                    </div>
                </div>
            )
        }
    }
    getTaps = () => {
        const tapsId = this.props.match.params.tapsId
        const color = this.props.match.params.color
        const location = this.props.match.params.location

        const url = `https://pl-api-dev.herokuapp.com/api/untappd/menu/${tapsId}`

        fetch(url)
        .then(res => res.json())
        .then(data => {
            const location = this.props.match.params.location
            let taps = data.menu.sections[0].items
            let tapsLeft
            let tapsRight
            
            if (location === 'pl9'){
                tapsLeft = taps.slice(0, 10)
                tapsRight = taps.slice(10)
                this.setState({
                    tapsMenu: data.menu,
                    tapsLeft, tapsRight, location
                })
            } else if (location === 'pl5'){
                tapsLeft = taps.slice(0,6)
                tapsRight = taps.slice(6)
                
                this.setState({
                    tapsMenu: data.menu,
                    tapsLeft, tapsRight, location
                })
            }
        })
        .catch(err => err)
    }
    componentDidMount(){
        this.getTaps()
    }
  
    render(){
        console.log(this.state)
        return(
            
                <div class="tap-beer-background ">
                    <div className="row">

               
                        
                                {this.state.tapsLeft 
                                    ? 
                                        
                                            this.sizeItemByLocation(this.state.tapsLeft, 'left')
                                      
                                    :   <span>loading...</span>
                                }
                            
                        <div className="column taps-right">
                            <div className="white taps-right-col">
                                {this.state.tapsRight
                                    ?
                                        
                                            this.sizeItemByLocation(this.state.tapsRight, 'right')
                                      
                                    :   <span>loading...</span>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                    
           
            
        )
    }
}
export default TapsHorizontal